import React, { useEffect, useRef } from "react";
import "./Abouthistory.css";
import mechanic from "../../assets/mechanic.jpeg";

/**
 * Premium AboutHistory – Enhanced Story Section
 * High-end UI with animations and glass morphism
 */
export default function Aboutheader({
  bgSrc = mechanic, // ✅ use the imported string path, not {mechanic}
  eyebrow = "ABOUT US",
  title = "The Story Behind Our Mobile Service",
  body = `Dempsey Mobile Service is a locally owned and operated mobile automotive repair and maintenance service, owned and operated by David Dempsey Sr. We offer everything from prepurchase inspections, check engine light diagnostics and brakes. We also offer oil changes, tune-ups, and so much more. Dempsey Mobile Service also offers small fleet services and discounts. Dempsey Mobile Service offers a service that cannot be denied! when you know you need service but don't have the time to wait and sit at an auto shop, Dempsey Mobile Services will come to you! We will come to your home, office, or just about anywhere to provide your vehicle with the best mobile service available. Make your appointment today, for piece of mind.`,
  body2 = "",
  body3 = "",
}) {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) el.classList.add("in-view");
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  // ✅ Safe background URL (string only)
  const bgUrl = typeof bgSrc === "string" && bgSrc.length ? bgSrc : mechanic;

  return (
    <section
      ref={sectionRef}
      className="ah-premium-section"
      aria-labelledby="about-history-title"
      style={{ backgroundImage: `url(${bgUrl})` }} // ✅ reliable background image
    >
      {/* Enhanced Background Layers */}
      <div className="ah-bg-overlay" aria-hidden="true" />
      <div className="ah-animated-glow" aria-hidden="true" />
      <div className="ah-glass-shard" aria-hidden="true" />
      <div className="ah-particle-field" aria-hidden="true" />

      {/* Floating Elements */}
      <div className="ah-floating-element ah-float-1" aria-hidden="true" />
      <div className="ah-floating-element ah-float-2" aria-hidden="true" />
      <div className="ah-floating-element ah-float-3" aria-hidden="true" />

      {/* Main Content */}
      <div className="ah-container">
        <div className="ah-content-wrapper">
          {/* Header */}
          <div className="ah-header-section">
            <div className="ah-eyebrow-wrapper">
              <span className="ah-eyebrow-badge">
                {eyebrow}
                <div className="ah-badge-glow" aria-hidden="true" />
              </span>
            </div>

            <h1 id="about-history-title" className="ah-main-title">
              <span className="ah-title-line ah-title-primary">
                {title.split(" ").slice(0, 3).join(" ")}
              </span>
              <span className="ah-title-line ah-title-accent">
                {title.split(" ").slice(3).join(" ") || "Our Mobile Service"}
              </span>
            </h1>

            <div className="ah-title-decoration">
              <div className="ah-divider-line" />
              <div className="ah-divider-dot" />
              <div className="ah-divider-line" />
            </div>
          </div>

          {/* Content Card */}
          <div className="ah-content-card" ref={contentRef}>
            <div className="ah-card-decoration" aria-hidden="true">
              <div className="ah-card-glow" />
              <div className="ah-card-corner ah-corner-tl" />
              <div className="ah-card-corner ah-corner-tr" />
              <div className="ah-card-corner ah-corner-bl" />
              <div className="ah-card-corner ah-corner-br" />
            </div>

            <div className="ah-content-body">
              <div className="ah-text-content">
                <p className="ah-main-text">{body}</p>
                {body2 ? <p className="ah-sub-text">{body2}</p> : null}
                {body3 ? <p className="ah-sub-text">{body3}</p> : null}
              </div>
            </div>
          </div>

          {/* (Optional) Features grid could go here */}
        </div>
      </div>
    </section>
  );
}
